var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRockHandIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 80,
    viewBox: "0 0 72 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.7503 18.3201H19.1103L19.1503 28.4201C16.3803 28.7001 11.5703 31.1901 11.5703 38.4801C11.5703 47.6301 26.0303 51.8701 26.0303 51.8701L48.4403 51.6001C48.4403 51.6001 59.8403 43.5801 53.7603 28.4201V18.3201H53.7503Z",
    fill: "#96CBFA",
    stroke: "#033967",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7109 78.1101H24.6309L26.0609 51.8701C26.0609 51.8701 41.0009 51.6901 48.4709 51.6001C48.5309 52.2801 49.7109 78.1101 49.7109 78.1101Z",
    fill: "white",
    stroke: "#033967",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4706 12.5101C21.0806 12.5101 19.1406 14.4501 19.1406 16.8401V28.3801C19.1406 30.7701 21.0806 32.7101 23.4706 32.7101C25.8606 32.7101 27.8006 30.7701 27.8006 28.3801V16.8401C27.8006 14.4501 25.8606 12.5101 23.4706 12.5101Z",
    fill: "white",
    stroke: "#033967",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1191 12.5101C29.7291 12.5101 27.7891 14.4501 27.7891 16.8401V28.3801C27.7891 30.7701 29.7291 32.7101 32.1191 32.7101C34.5091 32.7101 36.4491 30.7701 36.4491 28.3801V16.8401C36.4491 14.4501 34.5091 12.5101 32.1191 12.5101Z",
    fill: "white",
    stroke: "#033967",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7792 12.5101C38.3892 12.5101 36.4492 14.4501 36.4492 16.8401V28.3801C36.4492 30.7701 38.3892 32.7101 40.7792 32.7101C43.1692 32.7101 45.1092 30.7701 45.1092 28.3801V16.8401C45.0992 14.4501 43.1692 12.5101 40.7792 12.5101Z",
    fill: "white",
    stroke: "#033967",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4296 12.5101C47.0396 12.5101 45.0996 14.4501 45.0996 16.8401V28.3801C45.0996 30.7701 47.0396 32.7101 49.4296 32.7101C51.8196 32.7101 53.7596 30.7701 53.7596 28.3801V16.8401C53.7596 14.4501 51.8196 12.5101 49.4296 12.5101Z",
    fill: "white",
    stroke: "#033967",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1191 78.1101V51.8701",
    stroke: "#033967",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1194 51.8701C38.1194 41.4301 27.7994 38.4701 27.7994 38.4701H11.6094C11.6094 42.6301 15.0994 48.4601 26.0694 51.8601C35.5194 51.8701 38.1194 51.8701 38.1194 51.8701Z",
    fill: "white",
    stroke: "#033967",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5898 60.5001H48.8998",
    stroke: "#033967",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2.00012L8.57 8.57012H2.15L9 15.4201",
    stroke: "#033967",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5391 2.00012L62.9691 8.57012H69.3891L62.5391 15.4201",
    stroke: "#033967",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2 67.4201L8.57 60.8501H2.15L9 54.0001",
    stroke: "#033967",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5391 67.4201L62.9691 60.8501H69.3891L62.5391 54.0001",
    stroke: "#033967",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4296 12.5101C47.0396 12.5101 45.0996 14.4501 45.0996 16.8401V28.3801C45.0996 30.7701 47.0396 32.7101 49.4296 32.7101C51.8196 32.7101 53.7596 30.7701 53.7596 28.3801V16.8401C53.7596 14.4501 51.8196 12.5101 49.4296 12.5101Z",
    fill: "white",
    stroke: "#033967",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1794 28.4101H37.1594C37.1594 28.4101 44.2294 28.4101 44.2294 33.4401C44.2294 38.4701 37.2394 38.4701 37.2394 38.4701H11.6094C11.6094 32.0601 15.5094 28.7901 19.1794 28.4101Z",
    fill: "white",
    stroke: "#033967",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1406 19.3001H53.7506",
    stroke: "#033967",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRockHandIcon);
export default __webpack_public_path__ + "static/media/rock-hand-icon.3b5d5bc0667312e665628d80e5221563.svg";
export { ForwardRef as ReactComponent };